import React from 'react';
import styles from './UploadFilesField.module.scss';
import { fieldNames } from '../../../common/config';
import { Form, Upload } from 'antd';
import { validateFileSizeForForm } from '../../../../../../../helpers/validateFile';
import { maxFileSize } from '../../../../../../../constants/maxFileSize';
import { ReactComponent as AddFilesFromDocumentIcon } from '../../../../../../../resource/AddFilesFromDocumentIcon.svg';

const uploadDraggerFieldName = fieldNames.files;
const FormItem = Form.Item;
const { Dragger } = Upload;

const normFile = (e) => {
  return Array.isArray(e) ? e : e?.fileList || [];
};

const UploadFilesField = ({ form }) => {
  const handleChange = (info) => {
    if (info.fileList?.length) {
      const hasBigFile = info.fileList.some((file) => file.size > maxFileSize);

      if (hasBigFile) {
        const newFileList = info.fileList.map((file) => {
          if (file.size > maxFileSize) {
            file.status = 'error';
          }
          return file;
        });
        form.setFieldsValue({ [fieldNames.files]: newFileList });
      }
    }
  };

  return (
    <FormItem
      style={{ margin: 0 }}
      label="Вложения"
    >
      {form.getFieldDecorator(uploadDraggerFieldName, {
        rules: [
          {
            validator: validateFileSizeForForm,
          },
        ],
        valuePropName: 'fileList',
        getValueFromEvent: normFile,
      })(
        <Dragger
          multiple={true}
          beforeUpload={() => false}
          className={styles.customDragger}
          onChange={handleChange}
        >
          <p>
            <AddFilesFromDocumentIcon />
          </p>
          <p className={styles.title}>Выберите или перетащите документ</p>
          <p className={styles.description}>
            Любой формат файла, не более 15 МБ
          </p>
        </Dragger>
      )}
    </FormItem>
  );
};

export default UploadFilesField;
